import React, { FunctionComponent, useEffect, useState } from "react";

import DatasetMultiSelect from "components/basic/dropdowns/dataset/DatasetMultiSelect";
import TimeUnitDropdown from "components/basic/dropdowns/time-unit-dropdown/TimeUnitDropdown";
import { DashboardEditorProps } from "components/ComponentType";
import { InputNumber } from "primereact/inputnumber";
import { DweenTimeUnitEnum } from "utils/time-utils";
import { T } from "services/lang/LanguageService";
import { ICollapseDataTableProps } from "../DatasetCollapseDataTableTypes";

const defaultDatasetCollapseDataTableConfig: ICollapseDataTableProps = {
  config: {
    alignStartTo: DweenTimeUnitEnum.YEARS,
    lagOffset: 2,
    lagUnits: DweenTimeUnitEnum.YEARS,
  },
  datasets: [],
};

function DatasetCollapseDataTableEditor({ config, onConfigChange }: DashboardEditorProps<ICollapseDataTableProps>) {
  let conf = config ?? defaultDatasetCollapseDataTableConfig;

  if (Object.keys(conf).length === 0) {
    conf = defaultDatasetCollapseDataTableConfig;
  }

  const [currentConfig, setCurrentConfig] = useState<ICollapseDataTableProps>(conf);
  const [selectedDatasets, setSelectedDatasets] = useState<string[]>();

  if (conf.datasets && conf.datasets.length > 0 && !selectedDatasets) {
    const datasets = conf.datasets.map((dataset: any) => {
      return dataset.identifier;
    });
    setSelectedDatasets(datasets);
  }

  useEffect(() => {
    onConfigChange(currentConfig);
  }, [currentConfig]);

  const handleDatasetChange = (e: any) => {
    setSelectedDatasets(e);

    const selectedDatasetsArray = e.map((identifier: string) => {
      const oldDataset = currentConfig.datasets.find(data => data.identifier === identifier);
      if (oldDataset) return oldDataset;
      return { identifier };
    });

    setCurrentConfig({
      ...currentConfig,
      datasets: selectedDatasetsArray,
    });
  };

  const handleConfigChange = (e: any) => {
    setCurrentConfig({
      ...currentConfig,
      config: {
        ...currentConfig.config,
        [e.target.id]: e.target.value.toString().toUpperCase(),
      },
    });
  };

  return (
    <div>
      <div className="grid p-fluid">
        <div className="col-12 flex gap-2 flex-column mb-3">
          <label htmlFor="datasets">{T("word.datasets")}</label>
          <div className="flex">
            <DatasetMultiSelect id="datasets" value={selectedDatasets} onChange={handleDatasetChange} />
          </div>
        </div>
        <div className="col-4 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="lagOffset">{T("load-conf.lag-offset")}</label>
          <div className="p-inputgroup">
            <InputNumber
              id="lagOffset"
              className="w-6"
              value={currentConfig.config?.lagOffset as number}
              onValueChange={handleConfigChange}
              defaultValue={2}
            />
            <TimeUnitDropdown
              id="lagUnits"
              className="p-inputgroup-addon p-0 w-6"
              value={currentConfig.config?.lagUnits ? currentConfig.config.lagUnits : ""}
              onChange={handleConfigChange}
            />
          </div>
        </div>
        <div className="col-2 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="alignStartTo">{T("load-conf.align-start-to")}</label>
          <TimeUnitDropdown
            id="alignStartTo"
            className="p-0"
            value={currentConfig.config?.alignStartTo ? currentConfig.config.alignStartTo : ""}
            onChange={handleConfigChange}
          />
        </div>
      </div>
    </div>
  );
}

export default DatasetCollapseDataTableEditor as FunctionComponent;